import { FC } from "react";

export const StarsBadgeIcon: FC<{
  size?: number;
}> = ({ size = 20 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="stars-01" clip-path="url(#clip0_8121_2906)">
        <g id="Icon">
          <path
            d="M4.3335 8.66663L4.85647 9.71257C5.03346 10.0666 5.12196 10.2435 5.24018 10.3969C5.34509 10.533 5.4671 10.655 5.6032 10.7599C5.75657 10.8782 5.93357 10.9667 6.28755 11.1437L7.3335 11.6666L6.28755 12.1896C5.93357 12.3666 5.75657 12.4551 5.6032 12.5733C5.4671 12.6782 5.34509 12.8002 5.24018 12.9363C5.12196 13.0897 5.03346 13.2667 4.85647 13.6207L4.3335 14.6666L3.81052 13.6207C3.63353 13.2667 3.54503 13.0897 3.42681 12.9363C3.3219 12.8002 3.19989 12.6782 3.06379 12.5733C2.91042 12.4551 2.73343 12.3666 2.37944 12.1896L1.3335 11.6666L2.37944 11.1437C2.73343 10.9667 2.91042 10.8782 3.06379 10.7599C3.19989 10.655 3.3219 10.533 3.42681 10.3969C3.54503 10.2435 3.63353 10.0666 3.81052 9.71257L4.3335 8.66663Z"
            stroke="#3C82FD"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.3335 8.66663L4.85647 9.71257C5.03346 10.0666 5.12196 10.2435 5.24018 10.3969C5.34509 10.533 5.4671 10.655 5.6032 10.7599C5.75657 10.8782 5.93357 10.9667 6.28755 11.1437L7.3335 11.6666L6.28755 12.1896C5.93357 12.3666 5.75657 12.4551 5.6032 12.5733C5.4671 12.6782 5.34509 12.8002 5.24018 12.9363C5.12196 13.0897 5.03346 13.2667 4.85647 13.6207L4.3335 14.6666L3.81052 13.6207C3.63353 13.2667 3.54503 13.0897 3.42681 12.9363C3.3219 12.8002 3.19989 12.6782 3.06379 12.5733C2.91042 12.4551 2.73343 12.3666 2.37944 12.1896L1.3335 11.6666L2.37944 11.1437C2.73343 10.9667 2.91042 10.8782 3.06379 10.7599C3.19989 10.655 3.3219 10.533 3.42681 10.3969C3.54503 10.2435 3.63353 10.0666 3.81052 9.71257L4.3335 8.66663Z"
            stroke="url(#paint0_linear_8121_2906)"
            stroke-opacity="0.56"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g id="Icon_2">
          <path
            d="M10.0002 1.33337L10.7859 3.37632C10.9739 3.86514 11.0679 4.10955 11.2141 4.31514C11.3437 4.49734 11.5029 4.65654 11.6851 4.7861C11.8907 4.93228 12.1351 5.02629 12.6239 5.21429L14.6668 6.00004L12.6239 6.78579C12.1351 6.9738 11.8907 7.0678 11.6851 7.21398C11.5029 7.34354 11.3437 7.50274 11.2141 7.68495C11.0679 7.89053 10.9739 8.13494 10.7859 8.62376L10.0002 10.6667L9.21442 8.62376C9.02641 8.13494 8.9324 7.89053 8.78622 7.68495C8.65666 7.50274 8.49747 7.34354 8.31526 7.21398C8.10967 7.0678 7.86526 6.9738 7.37644 6.78579L5.3335 6.00004L7.37644 5.21429C7.86526 5.02629 8.10967 4.93228 8.31526 4.7861C8.49746 4.65654 8.65666 4.49734 8.78622 4.31514C8.9324 4.10955 9.02641 3.86514 9.21441 3.37632L10.0002 1.33337Z"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.0002 1.33337L10.7859 3.37632C10.9739 3.86514 11.0679 4.10955 11.2141 4.31514C11.3437 4.49734 11.5029 4.65654 11.6851 4.7861C11.8907 4.93228 12.1351 5.02629 12.6239 5.21429L14.6668 6.00004L12.6239 6.78579C12.1351 6.9738 11.8907 7.0678 11.6851 7.21398C11.5029 7.34354 11.3437 7.50274 11.2141 7.68495C11.0679 7.89053 10.9739 8.13494 10.7859 8.62376L10.0002 10.6667L9.21442 8.62376C9.02641 8.13494 8.9324 7.89053 8.78622 7.68495C8.65666 7.50274 8.49747 7.34354 8.31526 7.21398C8.10967 7.0678 7.86526 6.9738 7.37644 6.78579L5.3335 6.00004L7.37644 5.21429C7.86526 5.02629 8.10967 4.93228 8.31526 4.7861C8.49746 4.65654 8.65666 4.49734 8.78622 4.31514C8.9324 4.10955 9.02641 3.86514 9.21441 3.37632L10.0002 1.33337Z"
            stroke="#3C82FD"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.0002 1.33337L10.7859 3.37632C10.9739 3.86514 11.0679 4.10955 11.2141 4.31514C11.3437 4.49734 11.5029 4.65654 11.6851 4.7861C11.8907 4.93228 12.1351 5.02629 12.6239 5.21429L14.6668 6.00004L12.6239 6.78579C12.1351 6.9738 11.8907 7.0678 11.6851 7.21398C11.5029 7.34354 11.3437 7.50274 11.2141 7.68495C11.0679 7.89053 10.9739 8.13494 10.7859 8.62376L10.0002 10.6667L9.21442 8.62376C9.02641 8.13494 8.9324 7.89053 8.78622 7.68495C8.65666 7.50274 8.49747 7.34354 8.31526 7.21398C8.10967 7.0678 7.86526 6.9738 7.37644 6.78579L5.3335 6.00004L7.37644 5.21429C7.86526 5.02629 8.10967 4.93228 8.31526 4.7861C8.49746 4.65654 8.65666 4.49734 8.78622 4.31514C8.9324 4.10955 9.02641 3.86514 9.21441 3.37632L10.0002 1.33337Z"
            stroke="url(#paint1_linear_8121_2906)"
            stroke-opacity="0.56"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_8121_2906"
          x1="7.3335"
          y1="11.6721"
          x2="1.3335"
          y2="11.6715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F68EB4" />
          <stop offset="0.500638" stop-color="#CE5CFB" />
          <stop offset="1" stop-color="#2B78FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8121_2906"
          x1="14.6668"
          y1="6.00849"
          x2="5.33349"
          y2="6.00763"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F68EB4" />
          <stop offset="0.500638" stop-color="#CE5CFB" />
          <stop offset="1" stop-color="#2B78FF" />
        </linearGradient>
        <clipPath id="clip0_8121_2906">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
